var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import L from 'leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';
import HeaderTextDivider from '../header-text-divider';
import React, { useEffect, useState } from 'react';
import { Map, Marker, Popup, TileLayer, ZoomControl } from 'react-leaflet';
import { loadCssDesign } from '../utils/Utils';
var blueIcon = new L.Icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
var GlobalMap = function (_a) {
    var json_data = _a.json_data, getSelectedClientLanguage = _a.getSelectedClientLanguage, getTranslated = _a.getTranslated, getTranslation = _a.getTranslation, Icon = _a.Icon, history = _a.history, 
    // projectId,
    projectInfo = _a.projectInfo, CONSTANTS_REQ = _a.CONSTANTS_REQ, 
    //geti18nText,
    requestGet = _a.requestGet, RESPONSE = _a.RESPONSE, Button = _a.Button, _b = _a.projectType, projectType = _b === void 0 ? 'kiosk' : _b, _c = _a.allWebPagesAlias, allWebPagesAlias = _c === void 0 ? {} : _c, css_id = _a.css_id, css_json = _a.css_json, snapShot = _a.snapShot;
    var setLang = getSelectedClientLanguage();
    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
    var _d = useState(JSON.parse(json_data)), jsonData = _d[0], setJsonData = _d[1];
    var _e = useState([]), locations = _e[0], setLocations = _e[1];
    var _f = useState(undefined), clicked = _f[0], setClicked = _f[1];
    var _g = useState(undefined), zoom = _g[0], setZoom = _g[1];
    var _h = useState(undefined), center = _h[0], setCenter = _h[1];
    var _j = useState(0), _projectId = _j[0], setProjectId = _j[1];
    var _k = useState(0), mapHide = _k[0], setMapHide = _k[1];
    var _l = useState(450), arrowPosition = _l[0], setArrowPosition = _l[1];
    useEffect(function () {
        getLocations();
        mapRef.leafletElement.setMaxBounds(mapRef.leafletElement.getBounds());
        loadCssDesign(css_id, css_json, CONSTANTS_REQ);
    }, []);
    function getPageIds() {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    }
    function getLocations() {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestGet(snapShot && snapShot === true ? CONSTANTS_REQ.CLIENT.LOCATION_LIST_SNAPSHOT : CONSTANTS_REQ.CLIENT.LOCATION_LIST, {
                            max: 100,
                            active: true,
                            search: jsonData['locations'] != null && jsonData['locations'].length > 0
                                ? encodeURI(JSON.stringify([
                                    { field: 'id', condition: 'IN_PARSE_LONG', value: jsonData['locations'].toString() },
                                ]))
                                : null,
                        })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === RESPONSE.OK) {
                            setLocations(resp.data.content);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    var list = function (i) {
        if (typeof locations[i] === 'undefined') {
            if (i === -1) {
                i = locations.length - 1;
            }
            else {
                i = 0;
            }
        }
        setCenter([locations[i].latitude, locations[i].longitude]);
        setClicked(i);
        setZoom(15);
        mapRef.leafletElement.panTo([locations[i].latitude, locations[i].longitude], { animate: true });
    };
    function openLink(projectId, webPageId) {
        if (projectType === 'kiosk') {
            history.push("/" + projectId + "/" + webPageId);
        }
        else {
            if (allWebPagesAlias != {} && allWebPagesAlias[webPageId] != undefined) {
                history.push('/' + getSelectedClientLanguage() + '/' + allWebPagesAlias[webPageId]);
            }
            else {
                history.push('/' + getSelectedClientLanguage() + '/' + webPageId);
            }
        }
    }
    var getValidUrl = function (url) {
        if (url === void 0) { url = ''; }
        var newUrl = window.decodeURIComponent(url);
        newUrl = newUrl.trim().replace(/\s/g, '');
        if (/^(:\/\/)/.test(newUrl)) {
            return "https" + newUrl;
        }
        if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
            return "https://" + newUrl;
        }
        return newUrl;
    };
    function openUrlLink(link) {
        if (projectType === 'web' && link != null && link !== undefined) {
            window.open(getValidUrl(link), '_blank');
        }
    }
    var Sidebar = function () {
        return (React.createElement("div", { className: "globalmap-sidebar", style: { transform: "translateX(" + mapHide + "%)" } }, clicked == null ? (React.createElement(React.Fragment, null, locations != null &&
            locations.map(function (item, index) { return (React.createElement("div", { key: item.id, onClick: function () {
                    list(index);
                }, className: "globalmap-item" },
                item.headerImagePath && (React.createElement("img", { src: CONSTANTS_REQ.STATIC + _projectId + encodeURI(item.headerImagePath), style: { width: '150px', height: '100%' }, alt: item.name })),
                React.createElement("span", { className: "globalmap-text" }, item.name))); }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "globalmap-sidebarHeader" },
                React.createElement("button", { onClick: function () { return list(clicked - 1); }, className: "globalmap-sidebarButton" },
                    React.createElement(Icon, { type: "left" }),
                    React.createElement("span", null, getTranslation('component.globalmap.previous', setLang))),
                React.createElement("button", { onClick: function () { return list(clicked + 1); }, className: "globalmap-sidebarButton globalmap-next" },
                    React.createElement("span", null, getTranslation('component.globalmap.next', setLang)),
                    React.createElement(Icon, { type: "right" })),
                React.createElement("button", { className: "globalmap-sidebarButton globalmap-close", onClick: function () {
                        setCenter(undefined);
                        setClicked(undefined);
                        setZoom(undefined);
                    } },
                    React.createElement(Icon, { type: "close" }))),
            React.createElement("div", { className: "globalmap-sidebarHeaderImage", style: {
                    backgroundImage: "url(" + (CONSTANTS_REQ.STATIC + _projectId + locations[clicked].headerImagePath) + ")",
                } }),
            React.createElement("div", { className: "globalmap-sidebarTitle" }, locations[clicked].name),
            React.createElement("div", { className: "globalmap-sidebarBody" },
                React.createElement("div", { className: "thin-scrollbar globalmap-sidebarText", style: {
                        maxHeight: !locations[clicked].firstImagePath && !locations[clicked].secondImagePath
                            ? '280px'
                            : '180px',
                    } },
                    React.createElement("p", null, getTranslated(locations[clicked].contentText, setLang))),
                React.createElement("div", { className: "globalmap-sidebarThumbnails" },
                    locations[clicked].firstImagePath && (React.createElement("img", { src: CONSTANTS_REQ.STATIC +
                            _projectId +
                            encodeURI(locations[clicked].firstImagePath), alt: locations[clicked].firstImagePath })),
                    locations[clicked].secondImagePath && (React.createElement("img", { src: CONSTANTS_REQ.STATIC +
                            _projectId +
                            encodeURI(locations[clicked].secondImagePath), alt: locations[clicked].secondImagePath })))),
            locations[clicked].linkUrl !== null && projectType === 'web' && (React.createElement("a", { onClick: function () {
                    openUrlLink(locations[clicked].linkUrl);
                }, className: "globalmap-sidebarBodyLink" },
                React.createElement("span", null, getTranslation('component.globalmap.link', setLang)),
                React.createElement(Icon, { className: "globalmap-sidebarIconArrow", type: "arrow-right" }))),
            locations[clicked].webPage != null &&
                locations[clicked].webPage.id &&
                locations[clicked].webPage.projectId && (React.createElement("a", { onClick: function () {
                    openLink(locations[clicked].webPage.projectId, locations[clicked].webPage.id);
                }, className: "globalmap-sidebarBodyLink" },
                React.createElement("span", null, getTranslation('component.globalmap.link', setLang)),
                React.createElement(Icon, { className: "globalmap-sidebarIconArrow", type: "arrow-right" })))))));
    };
    var Title = function () {
        return jsonData.title != null && React.createElement(HeaderTextDivider, { title: getTranslated(jsonData.title, setLang) });
    };
    var SubTitle = function () {
        return (jsonData.subTitle != null && (React.createElement("p", { className: "globalmap-subtitle contrast-color" }, getTranslated(jsonData.subTitle, setLang))));
    };
    var MapPin = function (item, index) {
        return (React.createElement(Marker, { key: item.id, icon: blueIcon, onClick: function () { return setClicked(index); }, position: [item.latitude, item.longitude], onMouseOver: function (e) {
                e.target.openPopup();
            }, onMouseOut: function (e) {
                e.target.closePopup();
            } },
            React.createElement(Popup, null, item.name)));
    };
    var hideSidebar = function () {
        if (mapHide === -100) {
            setMapHide(0);
            setArrowPosition(450);
        }
        else {
            setMapHide(-100);
            setArrowPosition(0);
        }
    };
    var mapRef = null;
    return (React.createElement("div", { id: css_id, className: "globalmap-container" },
        React.createElement(Title, null),
        React.createElement(SubTitle, null),
        React.createElement(Map, { ref: function (ref) {
                mapRef = ref;
            }, center: center
                ? center
                : jsonData.latitude != null && jsonData.longitude != null
                    ? [jsonData.latitude, jsonData.longitude]
                    : [0, 0], zoom: zoom ? zoom : jsonData.zoom != null ? jsonData.zoom : 15, style: { height: '850px', width: '100%', marginTop: '50px' }, doubleClickZoom: false, trackResize: false, zoomControl: false, touchZoom: true, keyboard: false, gestureHandling: true, attributionControl: false, gestureHandlingOptions: {
                text: {
                    touch: projectInfo && projectInfo.mapZoomText && getTranslated(projectInfo.mapZoomText, setLang)
                        ? getTranslated(projectInfo.mapZoomText, setLang)
                        : 'Use two fingers to move the map',
                    scroll: 'Use ctrl + scroll to zoom the map',
                    scrollMac: 'Use \u2318 + scroll to zoom the map',
                },
            } },
            React.createElement(TileLayer, { attribution: '\u00A9 <a href="http://osm.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
            React.createElement(ZoomControl, { position: "topright" }),
            React.createElement(Sidebar, null),
            React.createElement("div", { className: "arrow-map " + (arrowPosition === 0 ? 'arrow-map-close' : 'arrow-map-open') },
                React.createElement(Button, { style: { background: 'none', border: 'none', fontWeight: 'bold' }, onClick: hideSidebar }, arrowPosition === 0 ? React.createElement(Icon, { type: "right" }) : React.createElement(Icon, { type: "left" }))),
            locations != null && locations.map(function (item, index) { return MapPin(item, index); }))));
};
export default GlobalMap;
//# sourceMappingURL=index.js.map